import { MenuItem } from './menu-item';

export enum DisplayColour {
  Normal,
  Warning
}

export class ContextMenuItem extends MenuItem {

  displayColour: DisplayColour = DisplayColour.Normal;
  disabled: boolean = false;
  tooltip: string | null = null;

  constructor(
    name: string, 
    action: string | (() => void), 
    displayColour: DisplayColour = DisplayColour.Normal,
    disabled: boolean = false,
    tooltip: string | null = null
  ) {
    super(name, action, false);
    this.displayColour = displayColour;
    this.disabled = disabled;
    this.tooltip = tooltip;
  }
}